import {Dimmer, Loader, Modal} from "semantic-ui-react";
import {CustomProvider, DatePicker, TimePicker} from "rsuite";
import {useSelector, useDispatch} from "react-redux";
import {getLanguage} from "../LanguageModal/reducer";
import translations from "../LanguageModal/translations";
import React, {useState, useEffect} from "react";
import ru_RU from 'rsuite/locales/ru_RU';
import {changeEvent, deleteEvent} from "../../views/Events/actions";
import {useNavigate} from "react-router";
import { ReactComponent as CloseIcon } from "../../icons/filter-close-button.svg";
import {getRolesAccess} from "../Roles/Roles";
import { Select } from "antd";

export default function EditPopup (props) {
    const {
        isPopupOpen,
        setIsPopupOpen,
        isLoading,
        event,
        options,
        deleteFunction,
        editFunction,
    } = props;

    const dispatch = useDispatch();
    const navigate = useNavigate();

    const userData = useSelector((state) => state.userLogin.userData);
    const roleAccess = getRolesAccess(userData.roles);

    const [formData, setFormData] = useState({});
    const [eventIsEditing, setEventIsEditing] = useState(false);


    useEffect(() => {
        setFormData({
            event_status: '',
            event_action: '',
            respondent_user: '',
            issue: '',
            on_date: '',
            on_time: '',
            duration: '',
            placement: '',
            add_info: '',
        });
    }, [])

    useEffect(() => {
        setFormData({
            event_status: event?.event_status?.code || '',
            event_action: event?.event_action?.code || '',
            respondent_user: event?.respondent_ca_user?.user_id || '',
            issue: event?.issue?.code || '',
            on_date: event?.on_date || '',
            on_time: event?.on_time || '',
            duration: event?.duration || '',
            placement: event?.placement || '',
            add_info: event?.add_info || '',
        })
        setEventIsEditing(false);

    }, [event, dispatch])



    // Язык
    const language = useSelector(getLanguage);
    const languageString = language[0]+language[1];
    const t = (key) => {
        const languageString = language[0]+language[1];
        const translation = translations[languageString];
        return translation ? translation[key] || key : key;
    };

    //

    const cancelEdit = () => {
        setFormData({
            event_status: event?.event_status?.code || '',
            event_action: event?.event_action?.code || '',
            respondent_user: event?.respondent_ca_user?.user_id || '',
            issue: event?.issue?.code || '',
            on_date: event?.on_date || '',
            on_time: event?.on_time || '',
            duration: event?.duration || '',
            placement: event?.placement || '',
            add_info: event?.add_info || '',
        })
        setEventIsEditing(false);
    }

    const editEvent = () => {
        if (!eventIsEditing) {
            setEventIsEditing(true);
        } else {
            editFunction(event?.id, formData);
        }
    }

    // Функции для изменения полей
    const handleChangeDateEdit = (value) => {
        setFormData({
            ...formData,
            on_date: value?.toLocaleDateString().split('.').reverse().join('-'),
        })
    }

    const handleCleanDateEdit= () => {
        setFormData({
            ...formData,
            on_date: ''
        })
    }

    const handleChangeTimeEdit = (value) => {
        setFormData({
            ...formData,
            on_time: value?.toLocaleTimeString(ru_RU, { hour: '2-digit', minute: '2-digit' })
        })
    }

    const handleCleanTimeEdit = () => {
        setFormData({
            ...formData,
            on_time: ''
        })
    }

    const handleChangeStatus = (value) => {
        setFormData({
            ...formData,
            event_status: value
        })
    }

    const handleChangeIssue = (value) => {
        setFormData({
            ...formData,
            issue: value
        })
    }

    const handleChangeDuration = (e) => {
        let value = e.target.value.replace(/[^0-9]/g, "");

        let formattedValue = "";
        if (value.length > 0) {
            formattedValue += value.substring(0, 2);
        }
        if (value.length > 2) {
            formattedValue += ":" + value.substring(2, 4);
        }

        if (+value.substring(0,2) > 23) {
            formattedValue = '23';
        }



        if (+value.substring(2,4) > 59) {
            formattedValue = value.substring(0, 2) + ':' + '59';
        }


        setFormData({ ...formData, duration: formattedValue });
    };

    const handleChangeAction = (value) => {
        setFormData({
            ...formData,
            event_action: value
        })
    }

    const handleChangePerson = (value) => {
        setFormData({
            ...formData,
            respondent_user: value
        })
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        setFormData({
            ...formData,
            [name]: value
        })
        console.log(formData);
    }

    console.log(options)

    const now = new Date();
    const disabledHours = (hour) => hour < now.getHours();
    const disabledMinutes = (minute, selectedHour) =>
        selectedHour === now.getHours() && minute < now.getMinutes();
    const disabledDate = (date) => date < now.setHours(0, 0, 0, 0);

    return (
        <Modal
            className='events-edit-modal scrolling'
            open={isPopupOpen}
            scrolling
            onClose={() => setIsPopupOpen(false)}
        >
            <Modal.Content className='events-modal-content'>
                <div className='events-modal-item'>
                    <CloseIcon className='events-close-icon' onClick={() => setIsPopupOpen(false)} />
                    <Dimmer
                        active={isLoading}
                        inverted
                    >
                        <Loader size="large">{t('loadingEvents')}</Loader>
                    </Dimmer>
                    <div className='events-modal-header'>
                        <div className='events-modal-title'>{event?.name}</div>
                        {/*<div className='events-modal-segment'>*/}
                        {/*    <div className='events-modal-label'>{t('author')}</div>*/}
                        {/*    <div>*/}
                        {/*        {*/}
                        {/*            languageString === 'ru' ? event?.initiator_user?.user_name : event?.initiator_user?.user_name_en*/}
                        {/*        }*/}
                        {/*    </div>*/}
                        {/*</div>*/}
                        <div className='events-modal-segment'  onClick={() => navigate(`../counterparty/${event?.respondent_ca?.ca_id}`)}>
                            <div className='events-modal-label'>{t('counterparty')}</div>
                            <div>
                                {
                                    languageString === 'ru' ? event?.respondent_ca?.ca_name : event?.respondent_ca?.ca_name_en
                                }
                            </div>
                        </div>
                        <div className='events-modal-segment'>
                            <div className='events-modal-label'>{t('eventStatus')}</div>
                            {!eventIsEditing ?
                                <div className='events-modal-text'>
                                    {
                                        languageString === 'ru' ? event?.event_status?.name?.ru : event?.event_status?.name?.en
                                    }
                                </div>
                                :
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    options={options.eventStatusesOptions}
                                    className='cform-drop'
                                    value={formData.event_status}
                                    onChange={handleChangeStatus}
                                    placeholder={t('selectStatus')}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />

                            }
                        </div>
                        <div className='events-modal-segment'>
                            <div className='events-modal-label'>{t('eventType')}</div>
                            <div className='events-modal-text'>
                                {
                                    languageString === 'ru' ? event?.event_action?.name?.ru : event?.event_action?.name?.en
                                }
                            </div>

                            {/*// <Select*/}
                            {/*//     showSearch*/}
                            {/*//     style={{width: '50%'}}*/}
                            {/*//     options={options.typeMeetingOptions}*/}
                            {/*//     className='cform-drop'*/}
                            {/*//     value={formData.event_action}*/}
                            {/*//     onChange={handleChangeAction}*/}
                            {/*//     placeholder={t('selectEventType')}*/}
                            {/*//     filterOption={(input, option) =>*/}
                            {/*//         option.label.toLowerCase().includes(input.toLowerCase())*/}
                            {/*//     }*/}
                            {/*// />*/}

                        </div>
                        <div className='events-modal-segment'>
                            <div className='events-modal-label'>{t('eventOutcome')}</div>
                            {!eventIsEditing ?
                                <div className='events-modal-text'>
                                    {
                                        languageString === 'ru' ? event?.issue?.name?.ru : event?.issue?.name?.en
                                    }
                                </div>
                                :
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    options={options.issuesOptions}
                                    className='cform-drop'
                                    value={formData.issue}
                                    disabled={formData.event_status === 'done'}
                                    onChange={handleChangeIssue}
                                    placeholder={t('selectOutcome')}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />

                            }
                        </div>
                        <div className='events-modal-segment'>
                            <div className='events-modal-label'>{t('employee')}</div>
                            {!eventIsEditing && roleAccess!== 'crm_administrator' ? <div>
                                    {
                                        languageString === 'ru' ? event?.respondent_ca_user?.user_name : event?.respondent_ca_user?.user_name_en
                                    }
                                </div> :
                                <Select
                                    showSearch
                                    style={{ width: '100%' }}
                                    options={[{
                                        label: languageString === 'ru' ? 'Любой сотрудник' : 'Any employeе',
                                        value: '0'
                                    }, ...options.usersOptions.map(option => ({
                                        label: option.text,
                                        value: option.value
                                    }))]}
                                    className='cform-drop'
                                    value={formData.respondent_user}
                                    onChange={handleChangePerson}
                                    placeholder={t('selectEmployee')}
                                    filterOption={(input, option) =>
                                        option.label.toLowerCase().includes(input.toLowerCase())
                                    }
                                />}
                        </div>
                        <div className='events-modal-segment'>
                            <div className='events-modal-label'>{t('dateAndTime')}</div>
                            <div style={{
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '10px',
                                marginTop: '5px'
                            }}>
                                {formData?.on_date && formData.on_date.split('-').reverse().join('.') + ' ' + formData.on_time}
                                {/*<CustomProvider locale={languageString=== 'ru' ? ru_RU : undefined}>*/}
                                {/*    <DatePicker*/}
                                {/*        onChange={handleChangeDateEdit}*/}
                                {/*        onClean={handleCleanDateEdit}*/}
                                {/*        shouldDisableDate={disabledDate}*/}
                                {/*        disabled*/}
                                {/*        format="dd/MM/yyyy"*/}
                                {/*        character=" – "*/}
                                {/*        appearance='subtle'*/}
                                {/*        placeholder={t('date')}*/}
                                {/*        value={new Date(formData.on_date + ' ' + formData.on_time)}*/}
                                {/*        ranges={[]}*/}
                                {/*        size='xs'*/}
                                {/*    />*/}
                                {/*    <TimePicker*/}
                                {/*        placeholder={t('time')}*/}
                                {/*        onChange={handleChangeTimeEdit}*/}
                                {/*        onClean={handleCleanTimeEdit}*/}
                                {/*        disabledHours={disabledHours}*/}
                                {/*        disabledMinutes={disabledMinutes}*/}
                                {/*        disabled*/}
                                {/*        showMeridiem={languageString!=='ru'}*/}
                                {/*        value={new Date(formData.on_date + ' ' + formData.on_time)}*/}
                                {/*        ranges={[]}*/}
                                {/*        size='xs'*/}
                                {/*    />*/}
                                {/*</CustomProvider>*/}
                            </div>
                        </div>
                        <div className='events-modal-segment'>
                            <div className='events-modal-label'>{t('duration')}</div>
                            {!eventIsEditing ?
                                <div>
                                    {event?.duration}
                                </div>
                                :
                                <input
                                    type="text"
                                    value={formData.duration}
                                    className='cform-input'
                                    onChange={handleChangeDuration}
                                    placeholder={languageString === 'ru' ? 'чч:мм' : 'hh:mm'}
                                    maxLength={5}
                                />
                            }
                        </div>
                        {/*<div className='events-modal-segment'>*/}
                        {/*    <div className='events-modal-label'>{t('placement')}</div>*/}
                        {/*    {!eventIsEditing ?*/}
                        {/*        <div>*/}
                        {/*            {event?.placement}*/}
                        {/*        </div>*/}
                        {/*        :*/}
                        {/*        <input*/}
                        {/*        className="cform-input"*/}
                        {/*        type="text"*/}
                        {/*        name='placement'*/}
                        {/*        style={{width: '50%'}}*/}
                        {/*        value={formData.placement}*/}
                        {/*        onChange={handleChange}*/}
                        {/*        disabled={!eventIsEditing}*/}
                        {/*    />}*/}
                        {/*</div>*/}
                        <div className='events-modal-segment'>
                            {(event?.add_info?.length > 0 || eventIsEditing) && <div className='events-modal-label'>{t('description')}</div>}
                            {!eventIsEditing ?
                                <div>
                                    {event?.add_info}
                                </div>
                                :
                                <textarea
                                    className="cform-input"
                                    type="text"
                                    name='add_info'
                                    value={formData.add_info}
                                    disabled={!eventIsEditing}
                                    onChange={handleChange}
                                />}
                        </div>
                    </div>
                </div>
                <div className='events-modal-btn-ctn'>
                    {event?.event_status?.name?.en !== 'Done' && event?.event_status?.name?.en !== 'Canceled' &&
                        <button className={'events-btn btn-red'}
                                onClick={editEvent}>{!eventIsEditing ? t('edit') : t('save')}</button>}
                    {eventIsEditing &&
                        <button
                            className='events-btn btn-white'
                            onClick={cancelEdit}
                        >
                            {t('cancel')}
                        </button>}
                    {/*{event?.event_status?.name?.en !== 'Done' && <button*/}
                    {/*    className='events-btn btn-gray'*/}
                    {/*    onClick={() =>deleteFunction(event?.id)}*/}
                    {/*>{t('delete')}</button>}*/}
                </div>

            </Modal.Content>
        </Modal>
    )
}